import React from 'react';
import { Check } from 'lucide-react';
import { Button } from 'reactstrap';
import { cn } from 'lib/utils';

const Step = ({ title, stepNumber, isCurrentStep, isCompleted }) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-relative">
      <div className="tw-flex tw-items-center tw-justify-center tw-z-10">
        <div
          className={`
            tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-semibold tw-text-white
            ${isCurrentStep ? 'tw-bg-blue-500' : isCompleted ? 'tw-bg-green-500' : 'tw-bg-gray-600'}
          `}
        >
          {isCompleted ? <Check className="tw-w-4 tw-h-4" /> : stepNumber}
        </div>
      </div>
      <p className="tw-text-sm tw-text-gray-600 tw-mt-2 tw-text-center tw-whitespace-nowrap">{title}</p>
    </div>
  );
};

export function Stepper({ steps, currentStep, onStepChange, isNextEnabled = true, lastText = 'Finish', children }) {
  const isLastStep = currentStep === steps.length - 1;
  return (
    <>
      <div className="tw-w-full tw-max-w-4xl tw-mx-auto tw-py-6">
        <div className="tw-flex tw-justify-between tw-items-center tw-gap-4 tw-relative">
          {steps.map((step, index) => (
            <React.Fragment key={step.title}>
              <div className="tw-flex-1 tw-relative">
                <Step
                  title={step.title}
                  stepNumber={index + 1}
                  isCurrentStep={index === currentStep}
                  isCompleted={index < currentStep}
                />
                {index < steps.length - 1 && (
                  <div className="tw-absolute tw-top-5 tw-left-[calc(50%+1.25rem)] tw-right-[calc(-50%+1.25rem)] tw-h-1">
                    <div
                      className={cn('tw-w-full tw-h-full', index < currentStep ? 'tw-bg-green-500' : 'tw-bg-gray-200')}
                    />
                  </div>
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      {children}
      <div className="tw-w-full tw-max-w-4xl tw-mx-auto">
        <div className="tw-flex tw-justify-between tw-gap-4 tw-mt-6">
          <Button
            className={cn(currentStep === 0 ? 'tw-opacity-50 tw-cursor-not-allowed' : 'tw-shadow-sm')}
            onClick={() => onStepChange(currentStep - 1)}
            disabled={currentStep === 0}
          >
            Previous
          </Button>
          <Button
            className={cn(isLastStep ? 'tw-opacity-50 tw-cursor-not-allowed' : '')}
            color={isLastStep ? 'success' : 'info'}
            onClick={() => onStepChange(currentStep + 1)}
            disabled={!isNextEnabled}
          >
            {isLastStep ? lastText : 'Next'}
          </Button>
        </div>
      </div>
    </>
  );
}
